export default "__VITE_ASSET__zfqWxI8W__"